"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var TRAVEL_STYLE_MAP = exports.TRAVEL_STYLE_MAP = {
    NAT_GEO_SIGNATURE: "National Geographic Signature"
};

/**
 * Returns true if any departure service has the Nat Geo Signature travel style.
 * @param {{ departure_services: {travel_style: {name: string}} }} bookingMeta
 */
var isNatGeoSignature = exports.isNatGeoSignature = function isNatGeoSignature(bookingMeta) {
    var services = bookingMeta && bookingMeta.departure_services && Array.isArray(bookingMeta.departure_services) ? bookingMeta.departure_services : [];

    return services.some(function (service) {
        return service && service.travel_style && service.travel_style.name === TRAVEL_STYLE_MAP.NAT_GEO_SIGNATURE;
    });
};


//////////////////
// WEBPACK FOOTER
// ./app/utils/mappings/travel-styles.js
// module id = 640
// module chunks = 0